module.exports = __webpack_public_path__ + "static/search-a959334ba3c1c251f42ceacd1a8e1df5.png";